import {
  Box,
  Button,
  Card,
  Checkbox,
  Chip,
  FormControlLabel,
  IconButton,
  InputAdornment,
  Modal,
  Stack,
  TextField,
  Typography
} from "@mui/material";
import { Search as SearchIcon } from "@mui/icons-material";
import CloseIcon from "@mui/icons-material/Close";
import { useEffect, useState } from "react";
import { Postrequestcall } from "../../request/Postrequest";
import {
  DELETE_USER_PRODUCTS,
  FETCH_PRODUCTS,
  SAVE_EXPERIENCES_PRODUCTS
} from "../../constant/Apipath";
import { useSelector } from "react-redux";
import InfiniteScroll from "react-infinite-scroll-component";
import Loader from "../../common/Loader";
import { BIBlue, BIGrey } from "../../assets/helpers";
import { English } from "../../constant/EnglishFallback";

export default function Addproducts(props) {
  const { loginData, multiLanguageData } = useSelector((state) => state?.main);

  const [searchProduct, setSearchproduct] = useState("");
  const [productType, setProductType] = useState(null);
  const [productCount, setProductCount] = useState(null);
  const [pageNo, setPageno] = useState(1);
  const [productList, setProductlist] = useState([]);
  const [allDataLoaded, setAllDataLoaded] = useState(false);
  const [showSelected, setShowselected] = useState(false);

  const [selectedProductIds, setSelectedProductIds] = useState([]);
  const [initialSelectedProductIds, setInitialSelectedProductIds] = useState([]);

  const [loader, setIsloader] = useState(false);

  const {
    TEXT_SELECT_PRODUCTS = English?.Profile?.TEXT_SELECT_PRODUCTS,
    TEXT_PRODUCTS_ARRAY_TOOLS = English?.Profile?.TEXT_PRODUCTS_ARRAY_TOOLS,
    TEXT_PRODUCTS_ARRAY_MATERIALS = English?.Profile?.TEXT_PRODUCTS_ARRAY_MATERIALS,
    TEXT_SHOW_ALL = English?.Profile?.TEXT_SHOW_ALL,
    TEXT_SHOW_SELECTED = English?.Profile?.TEXT_SHOW_SELECTED,
    BUTTON_SUBMIT = English?.Profile?.BUTTON_SUBMIT,
    TEXT_SEARCH_PRODUCTS = English?.Profile?.TEXT_SEARCH_PRODUCTS
  } = multiLanguageData?.Profile || {};

  // Initialize selected products from props
  useEffect(() => {
    if (props.showProducts === true) {
      const ids = props.selectedProducts.map((p) => p.productId);
      setSelectedProductIds(ids);
      setInitialSelectedProductIds(ids); // Save initial state for diff on submit
      getProducts(1, searchProduct, productType, true, ids);
    }
    return () => {
      setProductlist([]);
      setSelectedProductIds([]);
      setInitialSelectedProductIds([]);
      setSearchproduct("");
      setShowselected(false);
    };
    // eslint-disable-next-line
  }, [props.showProducts]);

  // Fetch products (with infinite scroll support)
  const getProducts = async (
    CurrPageNo,
    searchTerm,
    productType,
    reset = false,
    selectedIds = selectedProductIds // default to current state if not provided
  ) => {
    try {
      let filterDataFor;
      if (productType) {
        filterDataFor = productType === "Tools" ? "Tool" : "Material";
      }
      let subObj = productType
        ? { ProductType: filterDataFor, name: searchTerm }
        : { name: searchTerm };
      const getObj = {
        PageNr: CurrPageNo,
        NrOfRecPerPage: 20,
        FullSearch: "",
        UserId: loginData?.userInformation?.UserId,
        IncludeRecordNr: "true",
        TypeOfObjectReturned: "",
        FetchAllowedRecordsOnly: "true",
        SearchList: [subObj],
        DoNotSearchInSystemFields: true,
        SortList: [{ FieldName: "Name", Direction: "ASC" }]
      };
      let getResponse = await Postrequestcall(FETCH_PRODUCTS, getObj, loginData?.accessToken);
      if (getResponse.status === 201) {
        setProductCount(getResponse?.data?.nrOfRecords);
        const data = getResponse?.data?.data;
        if (data.length === 0 || getResponse?.data?.nrOfRecords === data?.length) {
          setAllDataLoaded(true);
        } else {
          setAllDataLoaded(false);
        }
        let combinedData = reset ? data : [...productList, ...data];
        // Mark selected
        combinedData = combinedData.map((item) => ({
          ...item,
          selected: selectedIds.includes(item.id),
          productId: item.id,
          productName: item.name
        }));
        setProductlist(combinedData);
        setPageno(CurrPageNo + 1);
      }
    } catch (error) {
      // Handle error
    } finally {
    }
  };

  // Only update local state on toggle
  const handleProductToggle = (product) => {
    setSelectedProductIds((prev) =>
      prev.includes(product.productId)
        ? prev.filter((id) => id !== product.productId)
        : [...prev, product.productId]
    );
    setProductlist((productList) =>
      productList.map((item) =>
        item.productId === product.productId ? { ...item, selected: !item.selected } : item
      )
    );
  };

  // Filtered selected products for "Show Selected"
  const selectedProductsList = productList.filter((item) =>
    selectedProductIds.includes(item.productId)
  );

  // Search, filter, and type handlers
  const onProductTypeClick = (type) => {
    const newType = productType !== type ? type : null;
    setProductType(newType);
    getProducts(1, searchProduct, newType, true);
  };
  const onSearchproduct = (e) => {
    let inputValue = e.target.value;
    const cleanedValue = (inputValue = inputValue.replace(/^[^A-Za-z0-9]+/, ""));
    if (cleanedValue !== searchProduct) {
      setSearchproduct(inputValue);
      getProducts(1, inputValue, productType, true);
    }
  };

  const clearSearchProduct = () => {
    setSearchproduct("");
    getProducts(1, "", productType, true);
  };

  // On submit, call both APIs as needed
  const handleSubmit = async () => {
    setIsloader(true);
    try {
      // Find products to add and remove
      const toAdd = selectedProductIds.filter((id) => !initialSelectedProductIds.includes(id));
      const toRemove = initialSelectedProductIds.filter((id) => !selectedProductIds.includes(id));
      // Call SAVE_EXPERIENCES_PRODUCTS for new selections
      if (toAdd.length > 0) {
        await Postrequestcall(
          SAVE_EXPERIENCES_PRODUCTS,
          {
            UserId: loginData?.userInformation?.UserId,
            ReturnRecordId: true,
            ReturnRecordError: true,
            SaveList: toAdd.map((productId) => ({
              Id: 0,
              UserId: loginData?.userInformation?.UserId,
              UserExperinceId: 0,
              ProductIdList: productId,
              ModifiedBy: loginData?.userInformation?.UserId
            }))
          },
          loginData?.accessToken
        );
      }
      // Call DELETE_USER_PRODUCTS for deselections
      if (toRemove.length > 0) {
        await Postrequestcall(
          DELETE_USER_PRODUCTS,
          {
            UserId: loginData?.userInformation?.UserId,
            ReturnRecordId: false,
            ReturnRecordError: true,
            SoftDelete: true,
            DeleteList: toRemove.map((productId) => ({
              ProductId: productId,
              UserId: loginData?.userInformation?.UserId
            }))
          },
          loginData?.accessToken
        );
      }
      await props.getProducts(1);
      setIsloader(false);
      props.handleClose();
    } catch (error) {
      // Handle error
      console.log("handleSubmit-> Error While Updating Products: ", error);
    } finally {
    }
  };

  const onSelectProducts = () => {
    // Get the list of selected products from productList using selectedProductIds
    const getUpdatedlist = productList.filter((item) =>
      selectedProductIds.includes(item.productId)
    );
    props.setSelectedproducts(getUpdatedlist);
    props.handleClose();
    // onClear();
  };

  return (
    <Modal open={props.showProducts}>
      <Box className="user-modal-responsive" style={{ scrollbarWidth: "none" }}>
        {loader ? (
          <Loader />
        ) : (
          <>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
                pb: 1
              }}>
              <Typography className="add-title" style={{ margin: 0 }}>
                {TEXT_SELECT_PRODUCTS}
              </Typography>
              <Stack sx={{ gap: 2 }} direction={"row"} >
                <CloseIcon
                  style={{ color: "#083DB8", cursor: "pointer" }}
                  onClick={() => props.handleClose()}
                />
              </Stack>
            </Box>
            <Stack spacing={1}>
              <TextField
                size="small"
                placeholder={TEXT_SEARCH_PRODUCTS}
                value={searchProduct}
                onChange={onSearchproduct}
                slotProps={{
                  input: {
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon />
                      </InputAdornment>
                    ),
                    endAdornment: searchProduct ? (
                      <InputAdornment position="end">
                        <IconButton onClick={clearSearchProduct}>
                          <CloseIcon />
                        </IconButton>
                      </InputAdornment>
                    ) : null
                  }
                }}
              />
              <Stack sx={{ justifyContent: "space-between", alignItems: "center" }} direction={"row"}>
                <Typography sx={{ color: BIGrey }}>
                  {showSelected ? selectedProductsList?.length : productCount} Results
                </Typography>
                <Typography
                  onClick={() => setShowselected(!showSelected)}
                  color={BIBlue}
                  style={{ cursor: "pointer" }}>
                  {showSelected
                    ? TEXT_SHOW_ALL
                    : `${TEXT_SHOW_SELECTED} (${selectedProductsList?.length})`}
                </Typography>
              </Stack>
              <Stack sx={{ gap: 1 }} direction={"row"} >
                <Chip
                  label={TEXT_PRODUCTS_ARRAY_TOOLS}
                  onClick={() => onProductTypeClick("Tools")}
                  style={productType === "Tools" ? { backgroundColor: BIBlue, color: "White" } : {}}
                />
                <Chip
                  label={TEXT_PRODUCTS_ARRAY_MATERIALS}
                  onClick={() => onProductTypeClick("Material")}
                  style={
                    productType === "Material" ? { backgroundColor: BIBlue, color: "White" } : {}
                  }
                />
              </Stack>
              <Stack
                spacing={1}
                className="product-list"
                id="scrollablediv_prodcut"
                style={{ marginBottom: "-10px", scrollbarWidth: "none" }}>
                {showSelected ? (
                  selectedProductsList.map((item, index) => (
                    <Card
                      key={item.productId}
                      className="pagelist-content"
                      style={{ padding: "10px", overflow: "visible" }}
                      onClick={() => handleProductToggle(item)}>
                      <Stack sx={{ justifyContent: "space-between", alignItems: "center" }} direction={"row"}>
                        <Stack>
                          <Typography sx={{ fontSize: "15px" }}>{item?.productName}</Typography>
                          <Typography>{item?.manufacturerName}</Typography>
                        </Stack>
                        <FormControlLabel
                          control={
                            <Checkbox
                              color="primary"
                              checked={item?.selected}
                              style={{ color: BIBlue }}
                              name="present"
                            />
                          }
                        />
                      </Stack>
                    </Card>
                  ))
                ) : (
                  <InfiniteScroll
                    dataLength={productList?.length}
                    next={() => getProducts(pageNo, searchProduct, productType)}
                    hasMore={!allDataLoaded}
                    loader={
                      allDataLoaded ? null : (
                        <h4 style={{ display: "flex", justifyContent: "center" }}>
                          <Loader />
                        </h4>
                      )
                    }
                    scrollableTarget="scrollablediv_prodcut">
                    <Stack spacing={1}>
                      {productList.map((item, index) => (
                        <Card
                          key={item.productId}
                          className="pagelist-content"
                          style={{ padding: "10px", overflow: "visible", cursor: "pointer" }}
                          onClick={() => handleProductToggle(item)}>
                          <Stack sx={{ justifyContent: "space-between", alignItems: "center" }} direction={"row"}>
                            <Stack>
                              <Typography sx={{ fontSize: "15px" }}>{item?.productName}</Typography>
                              <Typography>{`${item?.manufacturerName} | ${item?.productType || "N/A"}`}</Typography>
                            </Stack>
                            <FormControlLabel
                              control={
                                <Checkbox color="primary" checked={item?.selected} name="present" />
                              }
                            />
                          </Stack>
                        </Card>
                      ))}
                    </Stack>
                  </InfiniteScroll>
                )}
              </Stack>
              <Button
                variant="contained"
                fullWidth
                color="primary"
                size="medium"
                onClick={props?.from === "experience" ? onSelectProducts : handleSubmit}>
                {BUTTON_SUBMIT || "Select"}
              </Button>
            </Stack>
          </>
        )}
      </Box>
    </Modal>
  );
}

